import { render, staticRenderFns } from "./TournamentsFilters.vue?vue&type=template&id=1a36b1e0&scoped=true&lang=pug"
import script from "./TournamentsFilters.vue?vue&type=script&lang=js"
export * from "./TournamentsFilters.vue?vue&type=script&lang=js"
import style0 from "./TournamentsFilters.vue?vue&type=style&index=0&id=1a36b1e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a36b1e0",
  null
  
)

export default component.exports